import { QueryClient } from "@tanstack/react-query";

// Global QueryClient instance
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 3, // Retry failed queries up to 3 times
      staleTime: 1000 * 60 * 5, // 5 minutes
      refetchOnWindowFocus: false, // Avoid refetching when the window regains focus
      refetchOnReconnect: true, // Refetch on reconnect
      refetchOnMount: false, // Avoid unnecessary refetch on mount
    },
  },
});

export default queryClient;
